import { lazy } from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Disclaimer = lazy(() => import("@mediaspace-react-components/features/disclaimer"));

export const PreComponent = lazy(
    () => import("@mediaspace-react-components/features/disclaimer/creation-tool/pre-component/Disclaimer")
);

export const render = getDsLayoutComponentRenderer(Disclaimer);
